export default "__VITE_ASSET__qVh1rRAu__"